// @ts-expect-error bender-url not typed
import clock from 'bender-url!../../images/illustrations/clock.svg'; // @ts-expect-error bender-url not typed

import computerError from 'bender-url!../../images/illustrations/computer-error.svg'; // @ts-expect-error bender-url not typed

import email from 'bender-url!../../images/illustrations/email.svg'; // @ts-expect-error bender-url not typed

import emailWarning from 'bender-url!../../images/illustrations/email-warning.svg'; // @ts-expect-error bender-url not typed

import door from 'bender-url!../../images/illustrations/door.svg'; // @ts-expect-error bender-url not typed

import closedDoor from 'bender-url!../../images/illustrations/closed-door.svg'; // @ts-expect-error bender-url not typed

import computerSprocket from 'bender-url!../../images/illustrations/computer-sprocket.svg'; // @ts-expect-error bender-url not typed

import archSmall from 'bender-url!../../images/illustrations/arch-small.svg'; // @ts-expect-error bender-url not typed

import archLarge from 'bender-url!../../images/illustrations/arch-large.svg'; // @ts-expect-error bender-url not typed

import hubspotLogo from 'bender-url!../../images/illustrations/hubspot-logo-orange-sprocket.svg'; // @ts-expect-error bender-url not typed

import successCheckmark from 'bender-url!../../images/illustrations/success-checkmark.svg'; // @ts-expect-error bender-url not typed

import negative from 'bender-url!../../images/illustrations/negative.svg'; // @ts-expect-error bender-url not typed

import neutral from 'bender-url!../../images/illustrations/neutral.svg'; // @ts-expect-error bender-url not typed

import happy from 'bender-url!../../images/illustrations/happy.svg';
export default {
  clock,
  computerError,
  email,
  emailWarning,
  door,
  closedDoor,
  computerSprocket,
  archSmall,
  archLarge,
  hubspotLogo,
  successCheckmark,
  negative,
  neutral,
  happy
};